export default __webpack_public_path__ + "static/media/hihat.0273528c.wav";